<page-header
  [title]="constants.strings.reports"
  [subtitle]="subtitle"
></page-header>

<div class="col-lg-6">
  <div>
    <ngx-datatable
      #myTable
      class="material"
      [headerHeight]="45"
      [rows]="reports"
      [scrollbarV]="false"
      [scrollbarH]="true"
      [footerHeight]="0"
      [columnMode]="'force'"
      [rowHeight]="60"
      [externalPaging]="false"
      [count]="length"
      (activate)="rowTappedNGX($event)"
    >
      <ngx-datatable-column name="Report Description" [resizeable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span style="font-weight: 600">{{ row?.title }}</span>
          <br />
          <span style="color: var(--app-text-grey)">{{ row?.subtitle }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [resizeable]="false"
        [sortable]="false"
        [canAutoResize]="false"
        [width]="100"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
          >
            <mat-icon>chevron_right</mat-icon>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div
    style="
      margin-top: 10px;
      margin-left: 5px;
      color: whitesmoke;
      font-style: italic;
    "
  >
    Request a new report by emailing us at
    <span
      ><a
        href="mailto:hello@remyrewards.co.uk"
        target="_blank"
        style="color: whitesmoke"
        >{{ email }}</a
      ></span
    >
    or by messaging us on Whatsapp
    <span
      ><a
        style="color: whitesmoke; font-style: italic"
        target="_blank"
        href="https://api.whatsapp.com/send?phone=447874475624"
        >+447874475624</a
      ></span
    >
  </div>
</div>

<loader [loading]="loading" title="Generating Report..."></loader>
